import type { OfferApi } from '@fourthwall/services/dist/OffersApiClient'
import type { Money } from '@fourthwall/services/dist/models/common'

import type { FormValues, Summary } from '../SamplesOrders.types'

export const mapValuesToSummary = (
  values: FormValues,
  credit: Money,
  offers: OfferApi.GetOffersResponse['offers'],
): Summary => {
  const items = values.items.reduce((previous, current) => {
    const quantity = current.quantity ? parseInt(`${current.quantity}`) : 0

    return previous + quantity
  }, 0)
  const subtotal = values.items.reduce((previous, current) => {
    const offer = offers.find((offer) =>
      offer.variants.some((variant) => variant.id === current.variantId),
    )
    const variant = offer?.variants.find((variant) => variant.id === current.variantId)
    const currentCost =
      variant && variant.cost && current.quantity
        ? variant.cost.value * parseInt(`${current.quantity}`)
        : 0

    return previous + currentCost
  }, 0)
  const aboveCreditValue = subtotal - credit.value

  return {
    items,
    subtotal,
    shipping: 0,
    samplesCredit: credit.value ? -Math.min(credit.value, subtotal) : undefined,
    profitsBalance: undefined, // not implemented yet
    total: aboveCreditValue > 0 ? aboveCreditValue : 0,
  }
}
